import React, { useState, useEffect, useRef } from "react";
import yerlembg from "../images/yerlemicon.svg";
import { Button } from "primereact/button";
import { API_IP } from "./AppConfig/AppConfig";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { TabView, TabPanel } from "primereact/tabview";
import { Checkbox } from "primereact/checkbox";
import { Typography } from "@mui/material";
import { InputTextarea } from "primereact/inputtextarea";

export default function Message({ setSidebarVisible }) {
  const toast = useRef(null);
  let apiUrl = `http://${API_IP}:7077`;
  const showSuccess = (detailText) => {
    toast.current.show({
      severity: "success",
      summary: "Başarılı",
      detail: detailText,
      life: 3000,
    });
  };
  const showError = (detailText) => {
    toast.current.show({
      severity: "error",
      summary: "Hata",
      detail: detailText,
      life: 3000,
    });
  };

  const handlePhoneChange = (e) => {
    // Extract only digits from the entered value
    const digitsOnly = e.target.value.replace(/\D/g, "");

    // Split the digits into groups of 10
    const groupedNumbers = digitsOnly.match(/.{1,10}/g) || [];

    // Set the grouped phone numbers in the state
    setPhoneNumbers(groupedNumbers);
  };

  const handleSelectStudentChange = async (e) => {
    setSelectedStudent(e.value);
  };

  const handleSelectSchemeChange = async (e) => {
    setSelectedSelectedSchemes(e.value);
  };

  const handleSendUserOnClick = async () => {
    if (messageText !== "" && messageText !== null) {
      try {
        for (const phoneNumber of phoneNumbers) {
          const response = await fetch(apiUrl + `/singleSms/send`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              phone: phoneNumber,
              message: messageText.replace(/\n/g, "\\n"),
            }),
          });

          const data = await response.json();

          if (data.response) {
            showSuccess(`Mesaj başarıyla gönderildi: ${phoneNumber}`);
          } else {
            showError(`Hata: Mesaj gönderilemedi : ${phoneNumber}`);
          }
        }
      } catch (error) {
        console.error(`Hata: ${error.message}`);
      }
    } else {
      showError("Mesaj Metni Boş Olamaz");
    }
  };

  const handleSendStudentOnClick = async () => {
    if (selectedStudent.length === 0) {
      console.log("Öğrenci seçilmedi.");
      return;
    }
    var messageTextLast = "";

    const value = selectedSchool; // Okulun port ve kod bilgisini alıyoruz
    const splitValues = value.split(" - "); // String'i "-" işaretine göre böler
    const port = splitValues[0]; // Port numarası
    const schoolCode = splitValues[1]; // Okul kodu
    const schoolName = splitValues.slice(2).join(" - "); // Okul adı
    sendLoginDataCheckbox
      ? (messageTextLast = "giris")
      : (messageTextLast = messageText.replace(/\n/g, "\\n"));
    if (messageTextLast !== "" && messageTextLast !== null) {
      for (const student of selectedStudent) {
        try {
          const response = await fetch(apiUrl + `/singleSms/send`, {
            method: "POST", // Varsayılan olarak POST isteği gönderiliyor
            headers: {
              "Content-Type": "application/json",
            },
            id: student.id,
            body: JSON.stringify({
              userName: student.username,
              userPassword: student.password,
              schoolCode: schoolCode,
              phone: student.phone,
              port: port,
              schoolDescription: schoolName,
              message: messageTextLast,
              messageType: selectedSystemType,
            }),
          });
          const data = await response.json(); // Response'un JSON içeriğini almak için await kullanılıyor
          if (data.response) {
            showSuccess(
              `Öğrenciye başarıyla mesaj gönderildi: ${student.name} ${student.surname}`
            );
          } else {
            showError(
              `Hata: Mesaj gönderilemedi : ${student.name} ${student.surname}`
            );
          }
        } catch (error) {
          console.error(`Hata: ${error.message}`);
        }
      }
    } else {
      showError("Mesaj Metni Boş Olamaz");
    }
  };
  const handleSendSchemasClick = async () => {
    if (schoolSchemes.length === 0) {
      return;
    }
    for (const schemes of selectedSchemes) {
      try {
        const encodedDescription = encodeURI(selectedSchoolDescription);

        const urlWithParams = `${
          apiUrl + `/collectivesms/allSmsSchool`
        }?port=${selectedPort}&schoolCode=${selectedGate}&schoolDescription=${encodedDescription}&message=${encodeURIComponent(
          messageText.replace(/\n/g, "\\n")
        )}&schemaId=${schemes.id}`;
        const response = await fetch(urlWithParams);
        if (response.ok) {
          showSuccess(`Servise başarıyla mesaj gönderildi: ${schemes.title}`);
        } else {
          showError(`Hata: Mesaj gönderilemedi : ${schemes.title}`);
        }
      } catch (error) {
        console.error(`Hata: ${error.message}`);
      }
    }
  };
  const handleSendSpecialClick = async () => {
    if (schoolSchemes.length === 0) {
      return;
    }

    for (const schemes of selectedSchemes) {
      try {
        const encodedDescription = encodeURI(selectedSchoolDescription);

        const urlWithParams = `${
          apiUrl + `/collectivesms/allSmsSchool`
        }?port=${selectedPort}&schoolCode=${selectedGate}&schoolDescription=${encodedDescription}&message=${encodeURIComponent(
          selectedSpecialMessage
        )}&schemaId=${schemes.id}&messageType=${selectedSystemType}`;
        const response = await fetch(urlWithParams);
        if (response.ok) {
          showSuccess(`Servise başarıyla mesaj gönderildi: ${schemes.title}`);
        } else {
          showError(`Hata: Mesaj gönderilemedi : ${schemes.title}`);
        }
      } catch (error) {
        console.error(`Hata: ${error.message}`);
      }
    }
  };

  const handleSelectSchool = async (e) => {
    const value = e.value; // Okulun port ve kod bilgisini alıyoruz

    const splitValues = value.split(" - "); // String'i "-" işaretine göre böler

    if (splitValues.length >= 3) {
      const port = splitValues[0]; // Port numarası
      const schoolCode = splitValues[1]; // Okul kodu
      const schoolName = splitValues.slice(2).join(" - "); // Okul adı

      setSelectedStudent(null);
      setSelectedSelectedSchemes(null);
      setSelectedSchool(value);
      if (activeTab === 0) {
        try {
          const response = await fetch(
            `http://${API_IP}:${port}/mobile/getStudentUserInfo`
          );

          if (response.ok) {
            const jsonData = await response.json();
            setSelectedSchoolStudents(jsonData);
            console.log(jsonData);
          } else {
            throw new Error("Failed to fetch student data");
          }

          // Eğer aktif sekme 1 ise farklı bir API isteği yap
        } catch (error) {
          showError("Seçilen Okul Aktif Değildir.");
          setSelectedSchool(null);
        }
      } else if (activeTab === 1 || activeTab === 2) {
        try {
          const response = await fetch(
            `http://${API_IP}:${port}/mobile/transportationSchema/findAllTransportationSchemas`
          );
          const jsonData = await response.json();
          setSchoolSchemes(jsonData);
          setSelectedPort(port);
          setSelectedGate(schoolCode);
          setSelectedSchoolDescription(schoolName);
        } catch (error) {
          showError("Seçilen Okul Aktif Değildir.");
          setSchoolSchemes(null);
        }
      }
    } else {
      console.log("Geçersiz format");
    }
  };
  const handleSelectSpecialMessage = (e) => {
    setSelectedSpecialMessage(e.value);
  };
  const handleChangeSendLoginStudent = (e) => {
    setSendLoginDataCheckbox(e.checked);
  };
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [schoolList, setSchoolList] = useState([]);
  const [selectedSpecialMessage, setSelectedSpecialMessage] = useState(null);
  const [schoolSchemes, setSchoolSchemes] = useState(null);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [selectedSchoolStudents, setSelectedSchoolStudents] = useState(null);
  const [selectedSchemes, setSelectedSelectedSchemes] = useState(null);
  const [selectedPort, setSelectedPort] = useState(null);
  const [selectedGate, setSelectedGate] = useState(null);
  const [selectedSchoolDescription, setSelectedSchoolDescription] =
    useState(null);
  const [messageText, setMessageText] = useState("");
  const [sendLoginDataCheckbox, setSendLoginDataCheckbox] = useState(true);
  const [selectedSystemType, setSelectedSystemType] = useState(null);

  const specialMessage = [
    {
      label: "Kullanıcı Bilgileri",
      value: "giris",
    },
  ];

  const systemTypes = [
    {
      label: "Okul",
      value: "school",
    },
    {
      label: "İşletme",
      value: "factory",
    },
  ];

  const fetchSchool = async () => {
    try {
      const response = await fetch(
        `http://${API_IP}:8999/digitalgate/list`
        // Token olmadan doğrudan istek atılıyor, headers kısmı kaldırıldı
      );

      if (!response.ok) {
        throw new Error("Veri çekme hatası");
      }
      const data = await response.json();
      // Verileri işleme veya kullanma aşaması buraya eklenebilir
      setSchoolList(data);
    } catch (error) {
      console.error("API'den veri alınırken bir hata oluştu:", error);
    }
  };

  useEffect(() => {
    fetchSchool();
  }, []);
  const handleTabChange = (e) => {
    setPhoneNumbers(null);
    setSelectedSchool(null);
    setSelectedStudent(null);
    setMessageText(null);
    setSelectedSelectedSchemes(null);
    setActiveTab(e.index);
  };

  const sendStudentsTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-comments mr-2" />
        {options.titleElement}
      </button>
    );
  };

  const sendSchoolsTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-comments mr-2" />
        {options.titleElement}
      </button>
    );
  };
  const sendSpecialTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-comments mr-2" />
        {options.titleElement}
      </button>
    );
  };

  const sendUsersTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-comments mr-2" />
        {options.titleElement}
      </button>
    );
  };

  return (
    <div className="card py-4 px-36">
      <div className="absolute top-2 left-2">
        <Button
          severity="info"
          label="Menu"
          icon="pi pi-bars"
          onClick={() => setSidebarVisible((visible) => !visible)}
        />
      </div>
      <Toast ref={toast} />

      <TabView activeIndex={activeTab} onTabChange={(e) => handleTabChange(e)}>
        <TabPanel
          header="Öğrenciye SMS Gönder"
          headerTemplate={sendStudentsTab}
        >
          <div className="relative h-screen bg-cyan-50 rounded-3xl flex flex-col justify-center items-center">
            <img
              src={yerlembg}
              alt="Logo"
              className="absolute h-full object-cover z-0 "
            />
            <div className="my-2 w-full flex-col h-2/3 items-center gap-4  flex ">
              <Dropdown
                value={selectedSchool}
                options={schoolList
                  .filter((item) => item.status) // Durumu true olanları filtrele
                  .map((item) => ({
                    label: item.description,
                    value: `${item.port} - ${item.code} - ${item.description}`,
                  }))}
                filter
                className="w-2/5"
                optionLabel="label"
                placeholder="SMS göndermek istediğiniz okulu seçiniz"
                onChange={handleSelectSchool}
              />

              <MultiSelect
                value={selectedStudent}
                onChange={(e) => handleSelectStudentChange(e)}
                options={selectedSchoolStudents}
                optionLabel={(student) => `${student.name} ${student.surname}`}
                filter
                placeholder="Mesaj göndermek istediğiniz öğrencileri seçiniz"
                maxSelectedLabels={7}
                className="w-2/5"
              />
              <div className="w-2/5 flex flex-row gap-2 rounded-md z-3 bg-white border border-gray-300 p-2 transition-shadow">
                <Checkbox
                  checked={sendLoginDataCheckbox}
                  onChange={(e) => handleChangeSendLoginStudent(e)}
                />

                <Typography variant="h8"> Giriş bilgilerini gönder </Typography>
              </div>
              <Dropdown
                value={selectedSystemType}
                options={systemTypes}
                onChange={(e) => setSelectedSystemType(e.value)}
                placeholder="Sistem tipini seçiniz"
                filter
                className="w-2/5"
                optionLabel="label"
              />
              {sendLoginDataCheckbox ? null : (
                <textarea
                  className="w-2/5 rounded-xl z-3 border border-gray-300 p-2 transition-shadow hover:border-blue-600 focus:outline-none focus:border-blue-500 focus:ring focus:ring-blue-200"
                  id="messageText"
                  value={messageText}
                  placeholder="Mesaj Metnini Giriniz"
                  onChange={(e) => setMessageText(e.target.value)}
                  rows={10}
                  cols={30}
                  style={{
                    whiteSpace: "pre-wrap",
                    overflow: "hidden",
                    resize: "none",
                  }}
                />
              )}

              <Button
                label="Mesaj gönderme işlemini tamamla"
                disabled={
                  selectedSystemType === null || selectedStudent === null
                }
                className="w-2/5"
                onClick={handleSendStudentOnClick}
                severity="info"
              />
            </div>
          </div>
        </TabPanel>
        <TabPanel header="Toplu SMS Gönder" headerTemplate={sendSchoolsTab}>
          <div className="relative h-screen bg-cyan-50 rounded-3xl flex flex-col justify-center items-center">
            <img
              src={yerlembg}
              alt="Logo"
              className="absolute h-full object-cover z-0 "
            />
            <div className="my-2 w-full flex-col h-2/3 items-center gap-4  flex ">
              <Dropdown
                value={selectedSchool}
                options={schoolList
                  .filter((item) => item.status) // Durumu true olanları filtrele
                  .map((item) => ({
                    label: item.description,
                    value: `${item.port} - ${item.code} - ${item.description}`,
                  }))}
                filter
                className="w-2/5"
                optionLabel="label"
                placeholder="SMS göndermek istediğiniz okulu seçiniz"
                onChange={handleSelectSchool}
              />
              <MultiSelect
                value={selectedSchemes}
                onChange={(e) => handleSelectSchemeChange(e)}
                options={schoolSchemes}
                optionLabel={(schemes) => `${schemes.title}`}
                filter
                placeholder="Mesaj göndermek istediğiniz servisleri seçiniz"
                maxSelectedLabels={7}
                className="w-2/5"
              />
              <textarea
                className="w-2/5 rounded-xl z-3 border border-gray-300 p-2 transition-shadow hover:border-blue-600 focus:outline-none focus:border-blue-500 focus:ring focus:ring-blue-200"
                id="messageText"
                value={messageText}
                placeholder="Mesaj Metnini Giriniz"
                onChange={(e) => setMessageText(e.target.value)}
                rows={10}
                cols={30}
                style={{
                  whiteSpace: "pre-wrap",
                  overflow: "hidden",
                  resize: "none",
                }}
              />

              <Button
                label="Mesaj gönderme işlemini tamamla"
                className="w-2/5"
                onClick={handleSendSchemasClick}
                severity="info"
              />
            </div>
          </div>
        </TabPanel>
        <TabPanel header="Hazır SMS Gönder" headerTemplate={sendSpecialTab}>
          <div className="relative h-screen bg-cyan-50 rounded-3xl flex flex-col justify-center items-center">
            <img
              src={yerlembg}
              alt="Logo"
              className="absolute h-full object-cover z-0 "
            />
            <div className="my-2 w-full flex-col h-2/3 items-center gap-4  flex ">
              <Dropdown
                value={selectedSchool}
                options={schoolList
                  .filter((item) => item.status) // Durumu true olanları filtrele
                  .map((item) => ({
                    label: item.description,
                    value: `${item.port} - ${item.code} - ${item.description}`,
                  }))}
                filter
                className="w-2/5"
                optionLabel="label"
                placeholder="SMS göndermek istediğiniz okulu seçiniz"
                onChange={handleSelectSchool}
              />
              <MultiSelect
                value={selectedSchemes}
                onChange={(e) => handleSelectSchemeChange(e)}
                options={schoolSchemes}
                optionLabel={(schemes) => `${schemes.title}`}
                filter
                placeholder="Mesaj göndermek istediğiniz servisleri seçiniz"
                maxSelectedLabels={7}
                className="w-2/5"
              />
              <Dropdown
                value={selectedSpecialMessage}
                options={specialMessage.map((item) => ({
                  label: item.label,
                  value: item.value,
                }))}
                filter
                className="w-2/5"
                optionLabel="label"
                placeholder="SMS göndermek istediğiniz okulu seçiniz"
                onChange={handleSelectSpecialMessage}
              />
              <Dropdown
                value={selectedSystemType}
                options={systemTypes}
                onChange={(e) => setSelectedSystemType(e.value)}
                placeholder="Sistem tipini seçiniz"
                filter
                className="w-2/5"
                optionLabel="label"
              />

              <Button
                label="Mesaj gönderme işlemini tamamla"
                className="w-2/5"
                onClick={handleSendSpecialClick}
                severity="info"
                disabled={
                  selectedSchemes === null ||
                  selectedSystemType === null ||
                  selectedSpecialMessage === null
                }
              />
            </div>
          </div>
        </TabPanel>
        <TabPanel header="Kullanıcıya SMS Gönder" headerTemplate={sendUsersTab}>
          <div className="relative h-screen bg-cyan-50 rounded-3xl flex flex-col justify-center items-center">
            <img
              src={yerlembg}
              alt="Logo"
              className="absolute h-full object-cover z-0 "
            />
            <div className="my-2 w-full flex-col h-2/3 items-center gap-4  flex ">
              <InputTextarea
                placeholder="Telefon Numaralarını Giriniz"
                value={phoneNumbers}
                onChange={handlePhoneChange}
                className="w-2/5 rounded-xl z-3 border border-gray-300 p-2 transition-shadow hover:border-blue-600 focus:outline-none focus:border-blue-500 focus:ring focus:ring-blue-200"
                rows={5}
                cols={30}
              />

              <textarea
                className="w-2/5 rounded-xl z-3 border border-gray-300 p-2 transition-shadow hover:border-blue-600 focus:outline-none focus:border-blue-500 focus:ring focus:ring-blue-200"
                id="messageText"
                value={messageText}
                placeholder="Mesaj Metnini Giriniz"
                onChange={(e) => setMessageText(e.target.value)}
                rows={10}
                cols={30}
                style={{
                  whiteSpace: "pre-wrap",
                  overflow: "hidden",
                  resize: "none",
                }}
              />

              <Button
                label="Mesaj gönderme işlemini tamamla"
                className="w-2/5"
                onClick={handleSendUserOnClick}
                severity="info"
              />
            </div>
          </div>
        </TabPanel>
      </TabView>
    </div>
  );
}
